// extracted by mini-css-extract-plugin
module.exports = {"infoWrapper":"ClientEmergencyInfo_infoWrapper__178ZI","itemTitle":"ClientEmergencyInfo_itemTitle__1-avp","itemText":"ClientEmergencyInfo_itemText__2LbeN"};